<!-- <p>my-list-inventory works!</p> -->
<div
  [ngClass]="{
    'my-list-inventory-container': screenSize === 1 || screenSize === 2,
    'my-list-inventory-container-mobile': screenSize === 3
  }"
>
  <div class="inventory-header">
    <div style="width: 100%; text-align: center">My Inventory</div>

    <button mat-mini-fab mat-dialog-close>
      <mat-icon>clear</mat-icon>
    </button>
  </div>
  <div class="inventory-mobile-scrolling">
    <div class="inventory-search-field">
      <mat-grid-list
        [cols]="screenSize === 3 ? 1 : 2"
        rowHeight="85px"
        gutterSize="10px"
      >
        <mat-grid-tile
          ><mat-form-field
            hideRequiredMarker
            subscriptSizing="dynamic"
            appearance="outline"
          >
            <mat-label>Search Inventory </mat-label>
            <input
              matInput
              [formControl]="inventoryFilter"
              [matAutocomplete]="auto"
            />
            <mat-autocomplete
              (optionSelected)="inventorySelect($event)"
              #auto="matAutocomplete"
            >
              <mat-option *ngIf="filteredInventory.length == 0"
                >No Inventory</mat-option
              >
              <mat-option
                *ngFor="let visitor of filteredInventory"
                [value]="visitor.listName"
              >
                {{ visitor.listName }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field></mat-grid-tile
        >
        <mat-grid-tile
          ><div class="upload-inventory">
            <div class="attachment-uploaded-content">
              <ng-container>
                <div class="attachment-name" style="justify-content: center">
                  <p>
                    <b>{{
                      selectedAttachments
                        ? (selectedAttachments.name | truncateCase : 10)
                        : "Upload"
                    }}</b>
                  </p>
                </div>
              </ng-container>
            </div>
            <button type="button" (click)="fileInput1.click()" mat-icon-button>
              <mat-icon> attach_file </mat-icon>
            </button>
            <input
              type="file"
              #fileInput1
              style="display: none"
              accept=".pdf, .jpeg, .png"
              multiple
              (change)="onAttachmentSelected($event)"
            /></div
        ></mat-grid-tile>
        <mat-grid-tile>
          <div class="button-inside-mat-grid">
            <button (click)="onCreateInventoryForm()" mat-raised-button>
              Create new Inventory
            </button>
          </div>
        </mat-grid-tile>
      </mat-grid-list>
    </div>
    <mat-divider></mat-divider>

    <div class="inventory-content mobile-detail-view">
      <!-- {{ data.userInventory | json }} -->
      <div class="table-wrapper" *ngIf="screenSize != 3">
        <table mat-table [dataSource]="filteredInventory">
          <ng-container matColumnDef="index">
            <th mat-header-cell *matHeaderCellDef>No.</th>
            <td mat-cell *matCellDef="let element; let i = index">
              {{ i + 1 }}
            </td>
          </ng-container>
          <ng-container matColumnDef="inventoryId">
            <th mat-header-cell *matHeaderCellDef>Inventory Id</th>
            <td mat-cell *matCellDef="let element">
              {{ element.inventoryId }}
            </td>
          </ng-container>

          <ng-container matColumnDef="listName">
            <th mat-header-cell *matHeaderCellDef>List Name</th>
            <td mat-cell *matCellDef="let element">
              {{ element.listName }}
            </td>
          </ng-container>

          <!-- <ng-container matColumnDef="noofitems">
            <th mat-header-cell *matHeaderCellDef>Email</th>
            <td mat-cell *matCellDef="let element">
              {{ element.email }}
            </td>
          </ng-container> -->
          <ng-container matColumnDef="deliveryDate">
            <th mat-header-cell *matHeaderCellDef>Delivery Date</th>
            <td mat-cell *matCellDef="let element">
              {{ element.deliveryDate | date }}
            </td>
          </ng-container>

          <ng-container matColumnDef="totalitems">
            <th mat-header-cell *matHeaderCellDef>Items</th>
            <td mat-cell *matCellDef="let element">
              {{ element.inventoryItems.length }}
            </td>
          </ng-container>
          <ng-container matColumnDef="detail">
            <th style="text-align: center" mat-header-cell *matHeaderCellDef>
              Details
            </th>
            <td style="text-align: center" mat-cell *matCellDef="let element">
              <button (click)="onClickDetails(element)" mat-raised-button>
                <mat-icon *ngIf="expandedDetail != element.inventoryId"
                  >add</mat-icon
                >
                <mat-icon
                  *ngIf="
                    isShowInventoryDetails &&
                    expandedDetail == element.inventoryId
                  "
                  >remove</mat-icon
                >
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>
      <div *ngIf="screenSize === 3">
        <app-inventory-details-card
          [inventory]="filteredInventory"
          (showDetails)="onClickDetails($event)"
        ></app-inventory-details-card>
      </div>
    </div>
    <mat-divider></mat-divider>
    <div *ngIf="expandedElement && expandedElement.assignVendor != null">
      Note: This inventory is linked to vendor request Id:
      {{ expandedElement.assignVendor }}
    </div>
    <div class="inventory-content" *ngIf="isShowInventoryDetails">
      <!-- {{ data.userInventory | json }} -->
      <div class="table-wrapper">
        <table mat-table [dataSource]="expandedElement.inventoryItems">
          <ng-container matColumnDef="index">
            <th mat-header-cell *matHeaderCellDef>No.</th>
            <td mat-cell *matCellDef="let element; let i = index">
              {{ i + 1 }}
            </td>
          </ng-container>
          <ng-container matColumnDef="itemName">
            <th mat-header-cell *matHeaderCellDef>Item Name</th>
            <td mat-cell *matCellDef="let element">
              {{ element.itemName }}
            </td>
          </ng-container>

          <ng-container matColumnDef="quantity">
            <th mat-header-cell *matHeaderCellDef>Quantity</th>
            <td mat-cell *matCellDef="let element">
              {{ element.quantity }}
            </td>
          </ng-container>
          <ng-container matColumnDef="units">
            <th mat-header-cell *matHeaderCellDef>Units</th>
            <td mat-cell *matCellDef="let element">
              {{ element.units }}
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="newDisplayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: newDisplayedColumns"></tr>
        </table>
      </div>
    </div>
  </div>

  <!-- <div class="inventory-actions">
    <button mat-raised-button mat-dialog-close cdkFocusInitial>Close</button>
  </div> -->
</div>
